import { render, staticRenderFns } from "./CompaniesView.vue?vue&type=template&id=b66ee1c6&scoped=true&"
import script from "./CompaniesView.vue?vue&type=script&lang=js&"
export * from "./CompaniesView.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesView.vue?vue&type=style&index=0&id=b66ee1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66ee1c6",
  null
  
)

export default component.exports